import React from 'react'
import { Helmet } from 'react-helmet'

const About = () => {
    return (
        <div>
            <Helmet>
                <title>About | Paresh Chandra Pothal</title>
                <meta name="description" content="Learn more about Paresh Chandra Pothal, his background, and his journey in AI, Machine Learning, and Full-Stack Development." />
                <meta name="keywords" content="about, Paresh Chandra Pothal, background, AI, Machine Learning, Full-Stack Development, journey" />
                <meta name="author" content="Paresh Chandra Pothal" />
            </Helmet>

            
            <section style={{ backgroundColor: "rgba(21, 21, 21, 1)" }} className="text-gray-40 body-font">
                <div className="container px-5 py-24 mx-auto flex flex-col">
                    <div className="lg:w-4/6 mx-auto">
                        <div className="rounded-lg h-64 overflow-hidden">
                            <img style={{ opacity: "0.5" }} alt="content" className="object-cover object-center h-full w-full" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR12vRhXVa3NcX8fEQ1o3UrxW6PdQvyOiXB0DkAir6DOCB-phCGpF2A81HWxKruYLgeg70&usqp=CAU" />
                        </div>
                        <div className="flex flex-col sm:flex-row mt-10">
                            <div className="sm:w-1/3 text-center sm:pr-8 sm:py-8">

                                <div className="flex flex-col items-center text-center justify-center">
                                    <h2 className="font-medium title-font mt-4 text-white text-lg">Swami Vivekanada Banabharati Vidyapith </h2>
                                    <div className="w-12 h-1 bg-green-500 rounded mt-2 mb-4"></div>
                                    <p className="text-base text-gray-400">Koraput, Odisha , 764020</p>
                                </div>
                            </div>
                            <div className="sm:w-2/3 sm:pl-8 sm:py-8 sm:border-l border-gray-800 sm:border-t-0 border-t mt-4 pt-4 sm:mt-0 text-center sm:text-left">
                                <p className="leading-relaxed text-lg mb-4 text-white">Duration: 2 Years(2018-2020)</p>
                                <p className="leading-relaxed text-lg mb-4 text-white">I completed my 10th grade at SVB School, where I spent two formative years. During my time there, I gained a strong foundation in subjects like Mathematics, Science, and English, which set the stage for my future academic pursuits. The supportive teachers and a vibrant learning environment at  School played a crucial role in shaping my educational journey.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container px-5 py-24 mx-auto flex flex-col">
                    <div className="lg:w-4/6 mx-auto">
                        <div className="rounded-lg h-64 overflow-hidden">
                            <img alt="content" className="object-cover object-center h-full w-full" src="https://vsvidyalaya.in/images/school01.png" />
                        </div>
                        <div className="flex flex-col sm:flex-row mt-10">
                            <div className="sm:w-1/3 text-center sm:pr-8 sm:py-8">

                                <div className="flex flex-col items-center text-center justify-center">
                                    <h2 className="font-medium title-font mt-4 text-white text-lg">Vyomanya Samastha Vidyalaya</h2>
                                    <div className="w-12 h-1 bg-green-500 rounded mt-2 mb-4"></div>
                                    <p className="text-base text-gray-400">Sunabeda, Koraput, Odisha, 763002</p>
                                </div>
                            </div>
                            <div className="sm:w-2/3 sm:pl-8 sm:py-8 sm:border-l border-gray-800 sm:border-t-0 border-t mt-4 pt-4 sm:mt-0 text-center sm:text-left">
                                <p className="leading-relaxed text-lg mb-4 text-white">Duration: 2 Years (2021-2023)</p>
                                <p className="leading-relaxed text-lg mb-4 text-white">I completed my 12th grade at VSV, where I spent two impactful years. During my time there, I developed a deep understanding of advanced subjects such as Physics, Chemistry, and Mathematics, which prepared me well for higher education. The dedicated teachers and the intellectually stimulating environment at VSV were instrumental in my academic and personal growth.</p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="container px-5 py-24 mx-auto flex flex-col">
                    <div className="lg:w-4/6 mx-auto">
                        <div className="rounded-lg h-64 overflow-hidden">
                            <img alt="content" className="object-cover object-center h-full w-full" src="https://img.collegepravesh.com/2016/05/IIIT-Bhubaneswar.jpg" />
                        </div>
                        <div className="flex flex-col sm:flex-row mt-10">
                            <div className="sm:w-1/3 text-center sm:pr-8 sm:py-8">

                                <div className="flex flex-col items-center text-center justify-center">
                                    <h2 className="font-medium title-font mt-4 text-white text-lg">International Institute Of Information Technology Bhubaneswar</h2>
                                    <div className="w-12 h-1 bg-green-500 rounded mt-2 mb-4"></div>
                                    <p className="text-base text-gray-400">Bhubaneswar, Odisha, 751003</p>
                                </div>
                            </div>
                            <div className="sm:w-2/3 sm:pl-8 sm:py-8 sm:border-l border-gray-800 sm:border-t-0 border-t mt-4 pt-4 sm:mt-0 text-center sm:text-left">
                                <p className="leading-relaxed text-lg mb-4 text-white">Duration: Continuing B-Tech (2023- 2027)</p>
                                <p className="leading-relaxed text-lg mb-4 text-white">I am currently pursuing my B.Tech degree in Computer Science and Engineering at IIIT Bhubaneswar. The rigorous curriculum and cutting-edge research opportunities have significantly broadened my knowledge and skills in various aspects of computer science. The collaborative environment, supportive faculty, and state-of-the-art facilities at IIIT Bhubaneswar have been pivotal in my academic and professional development, fueling my passion for AI and Machine Learning and Full Stack Developer.

                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default About
